import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CityService} from '@services/city.service';
import {AdService} from '@services/ad.service';
import {CommonService} from '@services/common.service';
import {Favorite} from '@models/favorite';
import {User} from '@models/user';
import {EMPTY_USER} from '@models/empty';
import {MatDialog} from '@angular/material/dialog';
import {AuthenticationService} from '@services/authentification.service';

@Component({
    selector: 'app-charges',
    templateUrl: './charges.component.html',
    styleUrls: ['./charges.component.scss']
})
export class ChargesComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() favoriteChange = new EventEmitter();
    user: User = Object.assign({}, EMPTY_USER);

    constructor(
        public cityService: CityService,
        public adService: AdService,
        public commonService: CommonService,
        public authenticationService: AuthenticationService,
        public dialog: MatDialog) {
    }

    edit(event, fields = '') {
        this.favorite = this.adService.cleanInput(this.favorite);
        this.favorite = this.adService.updateValues(this.favorite);
        this.favoriteChange.emit();
    }

    ngOnInit() {
        this.user = this.authenticationService.currentUser;
    }
}
